import { ArrowRight, MapPin } from 'lucide-react';
import { copy, FLAGSHIP } from '../../data/website';
import { FadeIn } from '../Reveal';

export const FlagshipExperience = ({ onEnquire }) => <section id="experiences" className="section-space gee-flagship" data-testid="flagship-section">
  <div className="site-container">
    <p className="eyebrow" data-testid="flagship-section-label">{copy.flagship.label}</p><h2 className="gee-heading" data-testid="flagship-heading">{copy.flagship.heading}</h2>
    <div className="gee-flagship-layout">
      <FadeIn className="gee-flagship-visual"><img src={FLAGSHIP.image} alt="Illustrative cinema auditorium, not a photograph of the Guptar Ghat venue" loading="lazy" /><span className="gee-image-caption" data-testid="flagship-image-caption">{FLAGSHIP.imageCaption}</span><div><MapPin size={16} /><span>Guptar Ghat, Ayodhya</span></div></FadeIn>
      <div className="gee-prose" data-testid="flagship-copy">
        <h3 className="gee-flagship-title" data-testid="flagship-title">{copy.flagship.title}</h3>
        {copy.flagship.paragraphs.map(text => <p key={text}>{text}</p>)}
        <p>{copy.flagship.intro}</p>
        <p className="gee-movement" data-testid="flagship-movement">{copy.flagship.movement}</p>
        {copy.flagship.context.map(text => <p key={text}>{text}</p>)}
        <a className="button button-dark" href="https://guptarghat.com" target="_blank" rel="noopener noreferrer" data-testid="flagship-enquire">{copy.flagship.cta}<ArrowRight size={17} /></a>
      </div>
    </div>
  </div>
</section>;